export { default as SelectMaterialsContentFiltersSidebar } from './SelectMaterialsContentFiltersSidebar';
